import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router'
import { Observable } from 'rxjs'
import { Store } from '@ngrx/store'
import { DatasetApiService } from '../services/dataset-api.service'
import { ToasterService } from '../services/toaster.service'
import { RouterUtilsService } from '../services/router-utils.service'
import { resolveCase } from './case-resolver-utils'

@Injectable({
    providedIn: 'root',
})
export class SharedCaseResolver implements Resolve<boolean> {
    constructor(
        private readonly datasetApi: DatasetApiService,
        private readonly store: Store,
        private readonly router: Router,
        private readonly toaster: ToasterService,
        private readonly routerUtils: RouterUtilsService
    ) {}

    resolve(route: ActivatedRouteSnapshot): Observable<boolean> {
        return resolveCase(true, {
            datasetApi: this.datasetApi,
            store: this.store,
            route: route,
            router: this.router,
            toaster: this.toaster,
            routerUtils: this.routerUtils,
        })
    }
}
